import { Button } from '@app/components/various/Button';
import { FormFieldset } from '@app/components/various/Form';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  label: string;
  isDisabled?: boolean;
  onRemove?: () => void;
}

export const CreateLookbookFormOption = ({ children, label, isDisabled = false, onRemove }: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation(['common']);

  return (
    <FormFieldset isDisabled={isDisabled}>
      <legend className="mb-3 flex w-full items-center justify-between gap-2">
        <span className="body-7">{label}</span>
        <Button variant="text" color="danger" onClick={onRemove}>
          {t('common:remove')}
        </Button>
      </legend>
      {children}
    </FormFieldset>
  );
};
